import CookieHelper from '../../common/helpers/cookieHelper'


class Embed {
  constructor() {
    this.Mobile= false;
    this.Article= false;
    this.Name= "";
    this.updateModel();
  }

  updateModel(){
    this.Mobile = (CookieHelper.readCookie("platform") !== '' && CookieHelper.readCookie("platform") !== null) ? CookieHelper.readCookie("platform") : false;
  }
}

module.exports = {
  create: () => new Embed()
}


// WEBPACK FOOTER //
// ./Statics/scripts/paywall/models/embed.js